import { defineRule } from 'vee-validate';
import { required, email, url } from '@vee-validate/rules';

export function define() {
	defineRule('required', required);
	defineRule('email', email);
	defineRule('url', url);
}
